import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './index.css';
import App from './App';

// ─── Protección anti Self-XSS (igual que Facebook) ──────────────────────────
// Esta advertencia disuade ataques de ingeniería social donde alguien convence
// al usuario de pegar código malicioso en la consola del navegador.
if (process.env.NODE_ENV === 'production') {
    // Limpiar consola para no dejar info de React en producción
    console.clear();

    const stopStyle   = 'font-size:40px;font-weight:bold;color:#ef4444;';
    const warnStyle   = 'font-size:15px;color:#f97316;font-weight:600;';
    const normalStyle = 'font-size:13px;color:#94a3b8;';

    console.log('%c⛔ STOP', stopStyle);
    console.log(
        '%cEsta es una función del navegador dirigida a desarrolladores.\n' +
        'Si alguien te indicó copiar y pegar algo aquí para obtener acceso\n' +
        'a una cuenta o para "añadir funciones", es un engaño.\n' +
        'Ejecutar código en esta consola puede comprometer tu cuenta.',
        warnStyle
    );
    console.log('%c— Equipo de seguridad Fenine', normalStyle);

    // Sobreescribir console.log en producción para no exponer info interna
    const noop = () => {};
    console.log  = noop;
    console.warn = noop;
    console.info = noop;
    // Mantenemos console.error para errores críticos
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
